import { Button, Form, Input, Modal, Spin, Select } from "antd";
import axios from "axios";
import React, { useEffect, useState } from "react";
import config from "../../config";
import authHeader from "../Authentication/authHeader";
import Swal from "sweetalert2";

export default function StockDamageModal({
  visible,
  handleModalClose,
  data,
  fetchStockList,
}) {
  const [form] = Form.useForm();
  const { Option } = Select;
  const [stockLoading, setStockLoading] = useState(false);
  useEffect(() => {
    form.setFieldsValue({
      center_id: data?.center?.center?.employee_id,
      center_name: data?.center?.center_name,
      product_id: data?.product?.product_id,
      batch_id: data?.batch_id,
      product_name: data?.product?.product_name,
    });
    console.log(data);
  }, [data, form]);

  const handleUpdate = (value) => {
    data.damage_type = value.damage_type;
    data.quantity = value.quantity;
    console.log(data)
    axios
      .post(`${config.baseUrl}/inventory/create_damageStock/`, data, {
        headers: authHeader(),
      })
      .then((response) => {
        console.log(response)
        if (response?.status === 201) {
          Swal.fire({
            title: "Success",
            text: "Damage Stock Out Successful",
            confirmButtonText: "Ok",
            icon: "success",
          }).then(() => {
            fetchStockList();
            handleModalClose();
            form.resetFields();
          });
        }
      })
      .catch((error) => {
        Swal.fire({
          title: "Error",
          text: error,
          confirmButtonText: "Ok",
          icon: "error",
        });
      });
  };
  return (
    <Modal
      title="Stock Out Damage Product "
      open={visible}
      onCancel={handleModalClose}
      footer={false}
    >
      <Form form={form} onFinish={handleUpdate} layout="horizontal">
        <Form.Item
          label="Center ID"
          name="center_id"
          labelCol={{ span: 6 }}
          rules={[{ required: true, message: "Center ID required" }]}
        >
          <Input placeholder="Center ID" readOnly />
        </Form.Item>
        <Form.Item
          label="Center Name"
          name="center_name"
          labelCol={{ span: 6 }}
          rules={[{ required: true, message: "Center ID required" }]}
        >
          <Input placeholder="Center ID" readOnly />
        </Form.Item>
        <Form.Item
          label="Product Name"
          name="product_name"
          labelCol={{ span: 6 }}
          rules={[{ required: true, message: "Product Name required" }]}
        >
          <Input placeholder="Product Name" readOnly />
        </Form.Item>
        <Form.Item
          label="Batch ID"
          name="batch_id"
          labelCol={{ span: 6 }}
          rules={[{ required: true, message: "Batch ID required" }]}
        >
          <Input placeholder="Batch ID" readOnly />
        </Form.Item>
        <Form.Item
          label="Damage Type"
          name="damage_type"
          labelCol={{ span: 6 }}
          rules={[{ required: true, message: "Damage Type Required" }]}
        >
          <Select placeholder="Select Damage Type" className="me-3">
            <Option value="Damage">Damage</Option>
            <Option value="Expired">Expired</Option>
          </Select>
        </Form.Item>
        <Form.Item
          label="Quantity"
          name="quantity"
          labelCol={{ span: 6 }}
          rules={[
            { required: true, message: "Quantity Required" },
            {
              pattern: /^[0-9]+(\.[0-9]+)?$/,
              message: "Only English numbers",
            },
          ]}
        >
          <Input placeholder="Quantity" />
        </Form.Item>
        <Form.Item>
          <Button
            className="ms-3"
            style={{
              backgroundColor: "#46604A",
              borderColor: "#46604A",
              color: "white",
            }}
            htmlType="submit"
            disabled={stockLoading}
          >
            Submit
            {stockLoading && <Spin size="small" style={{ marginLeft: 8 }} />}
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
}
